import { useState } from 'react';
import { AlertColor } from '@mui/material';

interface SnackbarState {
  message: string;
  isOpen: boolean;
  status: AlertColor;
}

export const useSnackbar = () => {
  const initialSnackbarState = {
    isOpen: false,
    message: '',
    status: 'success' as AlertColor,
  };
  const [open, setOpen] = useState<SnackbarState>(initialSnackbarState);

  return {
    open,
    setOpen,
    initialSnackbarState,
  };
};
